import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { isInquiryModeEnabled, onOpenInquiry } from '../state/inquiry-modal';

// Magh Mela 2026 Bathing Dates (Snan Dates)
export const bathingDates = [
  { id: 'paush', date: '3 Jan 2026', endDate: '5 Jan 2026', startDate: undefined },
  { id: 'makar', date: '14 Jan 2026', endDate: '16 Jan 2026', startDate: undefined },
  { id: 'mauni', date: '18 Jan 2026', endDate: '20 Jan 2026', startDate: undefined },
  { id: 'basant', date: '23 Jan 2026', endDate: '25 Jan 2026', startDate: undefined },
  { id: 'maghi', date: '1 Feb 2026', endDate: '3 Feb 2026', startDate: undefined },
  { id: 'maha', date: '15 Feb 2026', endDate: '17 Feb 2026', startDate: '13 Feb 2026' },
] as const;

interface MaghMelaPageContentProps {
  dateId: (typeof bathingDates)[number]['id'];
}

/**
 * Parse a human-readable date (e.g., "3 Jan 2026") to ISO format (YYYY-MM-DD)
 */
function parseDisplayDateToISO(displayDate: string): string | undefined {
  try {
    const date = new Date(displayDate);
    if (isNaN(date.getTime())) return undefined;
    return date.toISOString().split('T')[0];
  } catch {
    return undefined;
  }
}

/**
 * Add days to an ISO date string and return new ISO date string
 */
function addDaysToISO(isoDate: string, days: number): string {
  const date = new Date(isoDate);
  date.setDate(date.getDate() + days);
  return date.toISOString().split('T')[0];
}

export const MaghMelaPageContent: React.FC<MaghMelaPageContentProps> = ({ dateId }) => {
  const { t } = useTranslation(['home', 'common']);
  const event = bathingDates.find(
    (e) => e.id === dateId,
  ) as (typeof bathingDates)[number];

  const { date, startDate } = event;
  const checkIn = parseDisplayDateToISO(startDate || date);
  const checkOut = checkIn ? addDaysToISO(checkIn, 3) : undefined;

  const handleBookingClick = useCallback(() => {
    if (isInquiryModeEnabled) {
      onOpenInquiry({
        checkIn,
        checkOut,
      });
    } else {
      const params = new URLSearchParams();
      if (checkIn) params.set('from', checkIn);
      if (checkOut) params.set('to', checkOut);
      const queryString = params.toString();
      window.location.href = `/packages/reservation${queryString ? `?${queryString}` : ''}`;
    }
  }, [checkIn, checkOut]);

  return (
    <div className="flex flex-col w-full gap-6">
      <button
        onClick={handleBookingClick}
        className="px-6 py-4 w-full self-start md:w-auto bg-green-700 hover:bg-green-800 text-white rounded-md uppercase text-sm tracking-wider font-bold transition-colors"
      >
        {t('common:book-now')} &rarr;
      </button>
    </div>
  );
};
